import { useEffect, useState } from 'react'
import { AddBrandModal } from './component/addmodal'
import { useRESTapi } from '../../../../../hooks/rest_API'
import { Brand, BrandKeys, Product, ProductCategory, ProductKeys, employee, pagination } from '../../../../../types'
import { TablePagination } from '../../../../../components/table'
import { Button } from '@/src/components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/src/components/ui/table'
import { ButtonIcon } from '@/src/components/buttons/buttonIcon'
import { Pencil, Search, Trash } from 'lucide-react'
import { DeleteModal } from './component/deleteModal'
import { useAlertModal } from '@/src/hooks/alert_modal'
import { SkeletonTableAdmin } from '../../../components/skeltonTable'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { InputIcon } from '@/src/components/ui/input'
import { FilterComponent } from './component/filterComponent'
import { useDebounce } from '@/src/hooks/debounce_hook'

interface BrandList extends Brand {
  image: any,
  delete: any,
  edit: any,
  page_number: number,
}
type Props = {
  setSelectedId: (id: string) => any
}

export type filterObjectType = {
  productName?: string,
  categoryId?: string,
}
export enum filterObjectTypeKeys {
  productSkuName = 'productName',
  categoryId = 'categoryId',
}

export function BrandCRUD(props: Props) {

  const [products, set_products] = useState<BrandList[]>([])
  const [mode, set_mode] = useState<'edit' | 'add'>('add')
  const api = useRESTapi()
  const [update, setUpdate] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selected_product_id, set_selected_product_id] = useState<string>()
  const [page_selected, set_page_selected] = useState<number>(1)
  const [products_total, set_products_total] = useState<number>(1)
  const [per_page, set_per_page] = useState<number>(30)
  const [showDeleteModal, setshowDeleteModal] = useState(false)
  const [isDeleteoading, setIsDeleteLoading] = useState(false)
  const [isProductLoading, setisProductLoading] = useState(false)
  const alertModal = useAlertModal()
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showFilterPopover, setShowFilterPopover] = useState(false)
  const [filterObject, setfilterObject] = useState<filterObjectType>({
    categoryId: searchParams.get(filterObjectTypeKeys.categoryId) ? searchParams.get(filterObjectTypeKeys.categoryId)! : '',
    productName: searchParams.get(filterObjectTypeKeys.productSkuName) ? searchParams.get(filterObjectTypeKeys.productSkuName)! : ''
  })
  const debouncedSearchTerm = useDebounce<string>(filterObject.productName ? filterObject.productName : '', 600);


  const header: {
    label: ProductKeys | string,
    name: string
  }[] = [
      {
        label: 'page_number',
        name: "No"
      },
      {
        label: 'image',
        name: "Image"
      },
      {
        label: BrandKeys.M14_Title,
        name: "Title"
      },

      {
        label: 'edit',
        name: ''
      },
      {
        label: 'delete',
        name: ''
      },
    ]

  const updateUi = () => {
    setUpdate(!update)
  }

  async function delete_product(id?: number | string) {

    setIsDeleteLoading(true)
    try {

      const res = await api.Delete<{ success: boolean, data: BrandList[], message: string }>({
        url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/brands/${id}`,
        mode: 'admin',

      })
      updateUi();
      if (res.data.success===true) {
        alertModal.open_alert_modal({
          content: res.data.message || 'Brand deleted succesfully',
          footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
          title: 'Deleted'
        })
        setshowDeleteModal(false)
      } else {
        alertModal.open_alert_modal({
          content: res.data.message || 'Something went wrong',
          footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
          title: 'Error'
        })
      }
      
      
    } catch (error) {
      alertModal.open_alert_modal({
        content: 'Server error',
        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
        title: 'Error'
      })
      console.log(error)
    }

    setIsDeleteLoading(false)

  }

  function clickEditButton(id: string) {
    set_selected_product_id(id)
    setShowModal(true)
    set_mode('edit')
  }
  function clickDeleteButton(id: string) {
    set_selected_product_id(id)
    setshowDeleteModal(true)
  }
  function open_add_modal() {
    set_selected_product_id(undefined)
    setShowModal(true)
    set_mode('add')
  }

  useEffect(
    () => {
      props.setSelectedId('A8')
      const initData = async () => {

        setisProductLoading(true)
        try {
          const res = await api.get<{ success: boolean, data: BrandList[],message:string  }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/brands`,
            params: {
              perPage: per_page,
              page: page_selected,
              searchTerm: searchParams.get(filterObjectTypeKeys.productSkuName),
              categoryId: searchParams.get(filterObjectTypeKeys.categoryId)
            },
            mode: 'admin',

          })

          if (res.data.success === true) {
            // console.log(res.data)
            set_products(res.data.data.map(
              (item, index) => {
                item.page_number = ((page_selected - 1) * per_page) + (index + 1)
                item.image = <img className=' h-10 aspect-1' src={`${process.env.REACT_APP_BACKEND_URL}/${item.M14_Brand_image}`} alt="" />
                item.delete = <ButtonIcon icon={<Trash className="h-4 w-4" />} onClick={() => { set_selected_product_id(String(item.M14_Brand_id!)); setshowDeleteModal(true) }}></ButtonIcon>
                item.edit = <ButtonIcon icon={<Pencil className="h-4 w-4" />} onClick={() => clickEditButton(item.M14_Brand_id!.toString())}></ButtonIcon>
               
                return item;
              }
            ))
            // set_products_total(res.data.data.total)
            setisProductLoading(false)
          } else {
            alertModal.open_alert_modal({
              content: res.data.message,
              footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
              title: 'Error'
            })
          }
        } catch (error) {
          console.log(error)
          alertModal.open_alert_modal({
            content: 'Server Error',
            footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
            title: 'Error'
          })
        }

      }

      initData()

    }, [update,debouncedSearchTerm]
  )

  return (
    <div className='  grow flex flex-col items-center  overflow-hidden py-5 gap-2 px-1 sm:px-5'>
      <div className=' p-2 text-2xl font-bold'>Brand list</div>
      <AddBrandModal
        id={selected_product_id}
        show={showModal}
        closeModal={() => setShowModal(false)}
        updateUi={updateUi}
        mode={mode}
        setShow={setShowModal}
      />
      <DeleteModal
        show={showDeleteModal}
        setShow={setshowDeleteModal}
        onDelete={async () => {
          await delete_product(selected_product_id);
        }}
        isDeleteing={isDeleteoading}
      />
      <div className=' w-full flex justify-between' >
        <InputIcon
          value={filterObject.productName}
          onChange={(e) => {
            // searchParams.set(filterObjectTypeKeys.productSkuName, e.target.value)
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set(filterObjectTypeKeys.productSkuName, e.target.value);
            navigate(`?${newSearchParams.toString()}`, { replace: true });

            setfilterObject({
              ...filterObject,
              productName: e.target.value
            })
          }} classOuter=' md:min-w-[400px]' icon={<Search />}
          placeholder='Search'
        />
        <div className=' flex gap-2'>
          {/* <FilterComponent
            filterObj={filterObject}
            setFilterObj={setfilterObject}
            updateUi={updateUi}
            show={showFilterPopover}
            setshow={setShowFilterPopover}
          /> */}
          <Button onClick={open_add_modal} className=' '>Add</Button>
        </div>
      </div>
      <div className=' overflow-auto w-full  border rounded-md'>
        {
          isProductLoading ?
            <SkeletonTableAdmin />
            : <Table className='styled-table w-full'>
              <TableHeader >
                <TableRow>
                  {
                    header.map(
                      (header, index) => <TableHead key={index}>{header.name}</TableHead>
                    )
                  }
                </TableRow>
              </TableHeader>
              <TableBody>
                {
                  products.length === 0
                    ?
                    'No data'
                    :
                    products.map(
                      (row: any, index) => (
                        <TableRow key={index}>
                          {
                            header.map(
                              (header, index) => <TableCell key={index}>{row[header.label]}</TableCell>
                            )
                          }
                        </TableRow>
                      )
                    )

                }
              </TableBody>
            </Table>
        }
      </div>
      <div>
        <TablePagination totalRows={products_total} rowsPerPage={per_page} onClickIndex={(e) => { set_page_selected(e); updateUi() }} selectedPage={page_selected} />
      </div>
    </div>
  )
}
